"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SideNavSvgIcon = exports.SideNavIcon = exports.ToggleIcon = exports.makeDefaultIcon = exports.SettingsIcon = exports.LogoutIcon = void 0;
/** @prettier */
var react_1 = __importDefault(require("react"));
var R = __importStar(require("ramda"));
var Icons_1 = require("../../components/Icons");
__createBinding(exports, Icons_1, "LogoutIcon");
__createBinding(exports, Icons_1, "SettingsIcon");
var makeDefaultIcon = function (label) { return (react_1["default"].createElement(exports.SideNavIcon, { type: "circle-thin custom", text: R.head(label) })); };
exports.makeDefaultIcon = makeDefaultIcon;
var ToggleIcon = function (_a) {
    var sideNavState = _a.sideNavState, onClick = _a.onClick;
    var sideNavIcon = sideNavState
        ? 'fa fa-chevron-right'
        : 'fa fa-chevron-left';
    return (react_1["default"].createElement("a", { className: "vs-sidenav-toggle-icon", onClick: onClick },
        react_1["default"].createElement("i", { className: sideNavIcon })));
};
exports.ToggleIcon = ToggleIcon;
var SideNavIcon = function (_a) {
    var type = _a.type, text = _a.text;
    return R.isNil(text) ? (react_1["default"].createElement("i", { className: "fa fa-".concat(type, " vs-sidenav-icon") })) : (react_1["default"].createElement("div", { className: "fa-stack vs-stacked-icon class" },
        react_1["default"].createElement("i", { className: "fa fa-".concat(type, " vs-sidenav-icon") },
            react_1["default"].createElement("span", { className: "fa fa-stack-1x single-text" }, text))));
};
exports.SideNavIcon = SideNavIcon;
var SideNavSvgIcon = function (_a) {
    var children = _a.children;
    return react_1["default"].createElement("div", { className: "vs-sidenav-svg-icon" }, children);
};
exports.SideNavSvgIcon = SideNavSvgIcon;
